// src/components/AppShell.jsx
import React, { useMemo } from "react";
import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import "../styles/AppShell.css";

export default function AppShell({ children }) {
  const { user } = useAuth();

  const initials = useMemo(() => {
    const name = user?.name || user?.email || "";
    const parts = String(name).trim().split(/\s+/);
    const first = parts[0]?.[0] ?? "";
    const second = parts[1]?.[0] ?? "";
    return (first + second).toUpperCase() || "U";
  }, [user]);

  const displayName =
    user?.name ||
    user?.artist_name ||
    (user?.email ? user.email.split("@")[0] : "") ||
    "Artist workspace";

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <div className="sidebar-header">
          <Link to="/search" className="sidebar-brand">
            <div className="sidebar-logo">
              <img
              src="https://www.musicbase.io/logo.png"
              alt="MusicBase"
              className="sidebar-logo"
            />
            </div>
            <div className="sidebar-brand-text">
              <span className="sidebar-brand-title">MusicBase</span>
              <span className="sidebar-brand-sub">Artist workspace</span>
            </div>
          </Link>

          
        </div>

        {/* Main nav */}
        <div className="sidebar-main">
          <div className="sidebar-section">
            <div className="sidebar-section-label">Workspace</div>

            <nav className="sidebar-nav">
              <NavLink
                to="/search"
                className={({ isActive }) =>
                  "sidebar-link" + (isActive ? " sidebar-link--active" : "")
                }
              >
                <span className="sidebar-link-dot" />
                <span className="sidebar-link-label">Playlist Search</span>
              </NavLink>

              <NavLink
                to="/campaign"
                className={({ isActive }) =>
                  "sidebar-link" + (isActive ? " sidebar-link--active" : "")
                }
              >
                <span className="sidebar-link-dot" />
                <span className="sidebar-link-label">Campaigns</span>
              </NavLink>

            </nav>
          </div>
        </div>

        <div className="sidebar-footer">
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              "sidebar-footer-link" +
              (isActive ? " sidebar-footer-link--active" : "")
            }
          >
            <span className="footer-icon">⚙️</span>
            <span>Settings</span>
          </NavLink>
        </div>
      </aside>

      <main className="app-main">{children}</main>
    </div>
  );
}
